<template>
    <div class="card h-100">
        <div class="card-header">
            <h3 class="card-title mb-0">Attività recenti</h3>
            <!-- Micro-label esplicita: i Recent NON seguono il periodo selezionato. -->
            <p class="text-muted font-size-sm mb-0 mt-1" v-if="periodoIndipendente">
                Ultimi progetti e ultime modifiche, indipendenti dal periodo selezionato.
            </p>
        </div>
        <div class="card-body">
            <div v-if="loading" class="placeholder-glow text-center py-4">
                <span class="placeholder col-8"></span>
            </div>

            <BlockState v-else-if="nonDisponibile" stato="non_disponibile"
                        dettaglio="L'attività recente non è disponibile." />

            <div v-else class="row g-3">
                <div class="col-12 col-xl-6">
                    <h4 class="text-muted font-size-sm text-uppercase mb-2">Ultimi progetti</h4>
                    <p v-if="!progettiCreati.length" class="text-muted small mb-0">Nessun dato.</p>
                    <ul v-else class="list-unstyled mb-0">
                        <li v-for="(p, i) in progettiCreati" :key="'p' + i" class="border-bottom py-2">
                            <div class="fw-semibold small">{{ p.title || '—' }}</div>
                            <div class="text-muted" style="font-size: .78rem">
                                <span v-if="p.code">{{ p.code }} · </span>
                                <span v-if="p.date_event">evento {{ p.date_event }} · </span>
                                <span>creato {{ dataTesto(p.created_at) }}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="col-12 col-xl-6">
                    <h4 class="text-muted font-size-sm text-uppercase mb-2">Ultime modifiche</h4>
                    <p v-if="!modifiche.length" class="text-muted small mb-0">Nessun dato.</p>
                    <ul v-else class="list-unstyled mb-0">
                        <li v-for="(m, i) in modifiche" :key="'m' + i" class="border-bottom py-2">
                            <div class="fw-semibold small">{{ m.description || m.title || '—' }}</div>
                            <div class="text-muted" style="font-size: .78rem">
                                <span v-if="m.title">{{ m.title }} · </span>
                                <span v-if="m.user">{{ m.user }} · </span>
                                <span>{{ dataTesto(m.action_at) }}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BlockState from "./BlockState.vue";

export default {
    name: "RecentPanel",
    components: { BlockState },

    props: {
        recent: { type: Object, default: null },
        loading: { type: Boolean, default: false },
    },

    computed: {
        nonDisponibile() {
            return !this.loading && (this.recent === null || this.recent === undefined);
        },
        periodoIndipendente() {
            /* Guardia sul blocco, NON su nonDisponibile: l'intestazione della card
               e' fuori dalla catena v-if="loading", quindi questa computed viene
               valutata anche durante il caricamento, quando recent e' ancora null. */
            return !!(this.recent && this.recent.periodo_applicato === false);
        },
        progettiCreati() {
            const a = this.recent && this.recent.progetti_creati;
            return Array.isArray(a) ? a : [];
        },
        modifiche() {
            const a = this.recent && this.recent.modifiche;
            return Array.isArray(a) ? a : [];
        },
    },

    methods: {
        dataTesto(v) {
            if (!v) return "—";
            return String(v).replace("T", " ").slice(0, 16);
        },
    },
}
</script>
